import developmentConfig from './env.development';
// import productionConfig from './env.production';
// import localConfig from './env.local';

const {baseUrl, authUrl, authCode, signalRUrl} =  window.config || {};

const config = {
  baseUrl: baseUrl || developmentConfig.baseUrl,
  signalRUrl: signalRUrl || developmentConfig.signalRUrl,
  authUrl: authUrl || developmentConfig.authUrl,
  authCode: authCode || developmentConfig.authCode,
};

export default config;
